import { Dispatch, SetStateAction, useState } from 'react';
import { TbChecklist, TbPhotoEdit, TbWorldWww } from 'react-icons/tb';
import { OrderDataProps } from 'screens/OrderScreen';
import { BrandAddOn, ContentAddOn, HostingAddOn } from './addOn';

export interface AddOnOrderProps {
  orderData: OrderDataProps;
  setOrderData: Dispatch<SetStateAction<OrderDataProps>>;
}

const AddOnOrder = ({ orderData, setOrderData }: AddOnOrderProps) => {
  const [addOn, setAddOn] = useState('BRAND');

  const renderAddOnOrder = () => {
    switch (addOn) {
      case 'BRAND':
        return <BrandAddOn orderData={orderData} setOrderData={setOrderData} />;
      case 'HOSTING':
        return (
          <HostingAddOn orderData={orderData} setOrderData={setOrderData} />
        );
      case 'CONTENT':
        return (
          <ContentAddOn orderData={orderData} setOrderData={setOrderData} />
        );
    }
  };

  return (
    <div className="px-4 pt-6 pb-[150px] lg:mt-10 lg:w-[95%] lg:self-start lg:rounded-2xl lg:p-8 lg:shadow-order">
      <p className="mb-4 hidden text-xl font-semibold text-primary-black lg:block">
        Add ons
      </p>

      <div className="flex items-center justify-between lg:max-w-[600px]">
        {addOnList.map((item) => (
          <button
            onClick={() => setAddOn(item.value)}
            className={`flex h-[102px] w-[30%] flex-col items-center rounded-xl border py-4 px-3 lg:h-[164px] lg:w-[164px] lg:justify-center lg:px-10 ${
              addOn === item.value
                ? 'border-primary-light-blue text-primary-light-blue'
                : 'border-[#9FA6B0] text-[#9FA6B0]'
            }`}
          >
            <div>{item.icon}</div>
            <p className="mt-2 text-center text-xs font-bold lg:text-base">
              {item.title}
            </p>
          </button>
        ))}
      </div>

      {renderAddOnOrder()}
    </div>
  );
};

export default AddOnOrder;

const addOnList = [
  {
    value: 'BRAND',
    title: 'Brand identity',
    icon: <TbPhotoEdit className="h-8 w-8 lg:h-[45px] lg:w-[45px]" />,
  },
  {
    value: 'HOSTING',
    title: 'Hosting & Domain',
    icon: <TbWorldWww className="h-8 w-8 lg:h-[45px] lg:w-[45px]" />,
  },
  {
    value: 'CONTENT',
    title: 'Content Management',
    icon: <TbChecklist className="h-8 w-8 lg:h-[45px] lg:w-[45px]" />,
  },
];
